import { getOutboundMessage } from './outboundUtils';
export function createFriendAddOutbound(username) {
    return getOutboundMessage({
        _type: 'friend_add',
        parts: [{ name: 'username', stringValue: username }]
    });
}
export function createFriendRemoveOutbound(username) {
    return getOutboundMessage({
        _type: 'friend_remove',
        parts: [{ name: 'username', stringValue: username }]
    });
}
